__webpack_require__.p = "/language-cards_project2/";